import React from 'react';
import { Button, Flex, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.TwoFactorEnroll');
export default function TwoFacterEnrollOverview({
  nextButtonVariant,
  onNext
}) {
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colM"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "formTitle|title"
  }, t('overviewTitle')), /*#__PURE__*/React.createElement(Text, {
    variant: "formBody"
  }, t('overviewDescription')), /*#__PURE__*/React.createElement(Button, {
    onClick: onNext,
    style: {
      marginTop: 10
    },
    variant: nextButtonVariant
  }, t('nextText')));
}